<template>
  <el-select
    :value="value"
    :class="[$style.productPlacement]"
    class="is-no-tb-border is-r-border"
    :placeholder="placeholder"
    style="color: white;"
    @input="$emit('input', $event)"
    @change="onChange"
  >
    <el-option v-for="(location, index) in options" :key="index" :label="location.title" :value="location.id" />
  </el-select>
</template>

<script>
export default {
  name: 'CheckInBranchSelect',
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    options: {
      type: Array,
      default: () => [],
    },
    placeholder: {
      type: String,
      default: '請選擇服務地點',
    },
  },
  methods: {
    onChange(val) {
      this.$emit('change', val)
    },
  },
}
</script>

<style lang="scss" module>
@import '@src/design/layout_detail_steps.scss';

.productPlacement {
  position: absolute;
  z-index: 100;
  left: 0;

  :global {
    .el-input__inner {
      height: $tabs-item--header-height;
      border-radius: 0;
      border: 0;
      color: white;
      font-size: 16px;

      &::placeholder {
        color: white;
        opacity: 1;
      }
    }

    .el-input__icon {
      color: white;
    }
  }

  @include pad {
    top: 0;
  }
}

:global {
  .is-r-border > .el-input > .el-input__inner {
    background-color: $color-primary;
    text-align: center;
    color: white;
  }

  .is-r-border > .el-input {
    :global {
      .el-input__icon {
        color: white;
      }
    }
  }

  .el-select-dropdown__list {
    padding-top: 9px;
    padding-bottom: 9px;
  }

  .el-select-dropdown {
    border-radius: $border-radius;
  }
}
</style>
